module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/eu_bank_general_icon-d9392411dd67d264e79b235f84b25ff9.png";